<template>
  <input type="hidden" :name="csrfTokenName" :value="csrfTokenValue" />
</template>

<script>
  export default {
    computed: {
      csrfTokenName() {
        return Craft.csrfTokenName;
      },

      csrfTokenValue() {
        return Craft.csrfTokenValue;
      },
    },
  };
</script>
